import SectionWrapper from '@/components/Landing/SectionWrapper'
import { Carousel, CarouselContent, CarouselItem } from '@/components/ui/carousel'
import { compareScreenSizes, useScreenSize } from '@/hooks/useScreenSize'
import { ReactNode } from 'react'

const items = [
  {
    title: 'Video Generation',
    description: 'Make apps that make and edit videos',
    imgSrc:
      'https://res.cloudinary.com/dwx3u2p1d/image/upload/q_auto:low,w_640/v1744767209/coming_1_pmbq1f.jpg',
  },
  {
    title: 'Assistants',
    description: 'Make chat assistants that you can invoke from other apps like Slack & Whatsapp',
    imgSrc:
      'https://res.cloudinary.com/dwx3u2p1d/image/upload/q_auto:low,w_640/v1744767209/coming_2_q0hmgb.jpg',
  },
  {
    title: 'Monetization',
    description: 'Charge your users for access to your app',
    imgSrc:
      'https://res.cloudinary.com/dwx3u2p1d/image/upload/q_auto:low,w_640/v1744767211/coming_3_pbjqp7.jpg',
  },
]

const ComingItem = ({
  title,
  description,
  imgSrc,
}: {
  title: string
  description: string | ReactNode
  imgSrc: string
}) => {
  return (
    <div
      className="relative flex h-[500px] w-full flex-col justify-end overflow-clip rounded-2xl bg-cover bg-center p-5 text-white shadow-md"
      style={{ backgroundImage: `url(${imgSrc})` }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-transparent from-[34.57%] to-black/50" />
      <h2 className="!font-libre-baskerville pointer-events-none relative z-10 select-none text-[32px] font-bold">
        {title}
      </h2>
      <p className="!font-libre-baskerville pointer-events-none relative z-10 select-none text-[24px] leading-[110%]">
        {description}
      </p>
    </div>
  )
}

const Coming = () => {
  const screenSize = useScreenSize()
  const isMobile = compareScreenSizes(screenSize, 'md') < 0
  const isLargeScreen = compareScreenSizes(screenSize, 'lg') >= 0

  // Enable scrolling if we're on mobile OR if we're not showing all cards at once
  // On lg screens we show 3 cards, on md screens we show 2 cards
  const shouldEnableScroll = isMobile || items.length > (isLargeScreen ? 3 : 2)

  return (
    <SectionWrapper
      className="container mx-auto gap-[50px] px-5 py-16"
      title="Coming Soon on Sprites"
    >
      <Carousel
        opts={{
          align: 'start',
          dragFree: shouldEnableScroll,
          containScroll: shouldEnableScroll ? 'trimSnaps' : 'keepSnaps',
          watchDrag: shouldEnableScroll,
          skipSnaps: false,
          active: shouldEnableScroll,
        }}
        className="w-full"
      >
        <CarouselContent>
          {items.map((item, index) => (
            <CarouselItem key={index} className="md:basis-1/2 lg:basis-1/3">
              <ComingItem {...item} />
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    </SectionWrapper>
  )
}

export default Coming
